// frontend/src/stores/liveStore.ts — what the UI renders of the tab's one live
// client (lib/live — ADR-074 §9): whether this screen can still refresh, and
// since when it cannot. The client (plain TypeScript, outside React) writes it;
// the cannot-refresh band reads it. Nothing else lives here — the change tokens,
// the rhythm and the questions are the client's own business, never a page's.
//
// `lastContactAt` is the SERVER's clock at the last good contact, said only
// while the sign shows: a wrong local clock cannot lie about it, and a healthy
// tab does not move the store at every glance.

import { create } from 'zustand';
import type { LiveReport } from '../lib/live/liveClient.js';

export const useLiveStore = create<LiveReport>()(() => ({ status: 'off', lastContactAt: null, sinceToday: true, version: null, checking: false }));
